import { useEffect, useState } from 'react'

export const useScrollPosition = (ref?: React.RefObject<HTMLElement>) => {
    const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 })

    useEffect(() => {
        const handleScroll = () => {
            if (ref?.current) {
                setScrollPosition({
                    x: ref.current.scrollLeft,
                    y: ref.current.scrollTop,
                })
            }
        }

        const element = ref?.current
        element?.addEventListener('scroll', handleScroll)

        return () => element?.removeEventListener('scroll', handleScroll)
    }, [ref])

    return scrollPosition
}
